(self["webpackChunk"] = self["webpackChunk"] || []).push([[8358],{

/***/ 21927:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(83654);
/* harmony import */ var utils_floating_labels__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63595);
/* harmony import */ var utils_form_submit_toggle__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60125);



new utils_form_submit_toggle__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z('#registration_form', true);


/***/ }),

/***/ 63595:
/***/ ((__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8149);

(function($) {
    'use strict';
    $(()=>{
        $('.js-floating-labels').on('blur', '.form-control', function() {
            const $this = $(this);
            $this.parents('.q-floating-label-wrapper').removeClass('q-floating-label-wrapper--focused');
            if ($this.val() === '') $this.parents('.q-floating-label-wrapper').removeClass('q-floating-label-wrapper--filled');
            else $this.parents('.q-floating-label-wrapper').addClass('q-floating-label-wrapper--filled');
        }).on('focus', '.form-control', function() {
            $(this).parents('.q-floating-label-wrapper').addClass('q-floating-label-wrapper--focused');
        }).find('.form-control').each(function() {
            const $this = $(this);
            let isAutofill = false;
            try {
                isAutofill = $this.is(':-webkit-autofill');
            } catch (e) {
                isAutofill = false;
            }
            if ($this.val() !== '' || isAutofill) $this.parents('.q-floating-label-wrapper').addClass('q-floating-label-wrapper--filled');
        });
    });
})(window.jQuery);


/***/ }),

/***/ 60125:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ FormSubmitToggle)
/* harmony export */ });
class FormSubmitToggle {
    bind() {
        if (this.disableBtn) {
            this.handleSubmitBtn();
            this.$context.on('change', ()=>this.handleSubmitBtn());
        }
        this.$context.on('submit', (e)=>this.beforeSubmit(e));
    }
    handleSubmitBtn() {
        if (this.fieldsAreNotValid()) {
            this.disableSubmit();
        } else {
            this.enableSubmit();
        }
    }
    beforeSubmit(e) {
        if (this.fieldsAreNotValid()) {
            e.preventDefault();
            e.stopPropagation();
        }
    }
    enableSubmit() {
        this.$submitBtn.removeClass('disabled');
    }
    disableSubmit() {
        this.$submitBtn.addClass('disabled');
    }
    fieldsAreNotValid() {
        const invalidInputs = this.$requiredInputs.filter(function() {
            return this.checkValidity() === false;
        });
        return invalidInputs.length === 0 ? false : true;
    }
    constructor(formId, disableBtn){
        this.$context = window.jQuery(formId);
        this.$requiredInputs = this.$context.find('input').filter('[required]');
        this.$submitBtn = this.$context.find('input[type=submit]');
        this.disableBtn = disableBtn;
        this.bind();
    }
}



/***/ }),

/***/ 32118:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ LoginRegister)
/* harmony export */ });
/* harmony import */ var utils_ajax_component_loader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62346);
/* harmony import */ var utils_form_submit_toggle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60125);
/* harmony import */ var utils_modal_manager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87322);
/* harmony import */ var utils_validator__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91337);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}




const credentials = {
    development: {
        client_id: '1c35da89e00bf86c161e668d6aa01f31e075ed3311db945df2680ba4b6a27255',
        client_secret: '023630cc8053a175aefc301d25198bb1fd0499fe9d8a931e3abe6dd82cabe20a'
    },
    staging: {
        client_id: '5c4a9f9fe4234cf6cd6967a0d83266c26a4ac25edd3d4176ad62dff9de8e1b81',
        client_secret: '60e88b34ee54d2ffd71d7d87af726ef8e10bdb8f9907e0eebade0c83d0c5b6b4'
    },
    production: {
        client_id: '2cd360dd07bc856dd68bbbd2976f7e1aa1bdee7b359be4d236d7b04c03ec1284',
        client_secret: '22977b636e45831cd02796645a32b95ea435c9a0532e176756bf665b6e6cbb4a'
    }
};
class LoginRegisterModal {
    init() {
        this.btnLogin = window.jQuery('#button-login', this.container);
        this.btnRegister = window.jQuery('#button-register', this.container);
        this.modalRegister = window.jQuery('#modal-register', this.container);
        this.modalLogin = window.jQuery('#modal-login', this.container);
        this.btnLogin.on('click', ()=>{
            this.modalRegister.hide();
            this.modalLogin.show();
        });
        this.btnRegister.on('click', ()=>{
            this.modalRegister.show();
            this.modalLogin.hide();
        });
    }
    initNew() {
        this.btnLogin = window.jQuery('.button-login', this.container);
        this.btnLoginEmail = window.jQuery('.button-login-email', this.container);
        this.btnRegisterEmail = window.jQuery('.button-register-email', this.container);
        this.btnRegisterSocial = window.jQuery('.button-register-social', this.container);
        this.btnRecovery = window.jQuery('#button-recovery', this.container);
        this.btnTogglePassword = window.jQuery('.btn-toggle', this.container);
        this.btnResend = window.jQuery('#resendCode', this.container);
        this.modalLogin = window.jQuery('#modal-login', this.container);
        this.modalRegister = window.jQuery('#modal-register', this.container);
        this.modalRegisterSocial = window.jQuery('#modal-register-social', this.container);
        this.modalRecovery = window.jQuery('#modal-recovery', this.container);
        this.modalWelcome = window.jQuery('#modal-welcome', this.container);
        this.modalCode = window.jQuery('#modal-code', this.container);
        this.modalPassword = window.jQuery('#modal-password', this.container);
        // login
        this.btnLogin.on('click', (e)=>{
            e.preventDefault();
            this.modalRegister.addClass('hidden');
            this.modalRegisterSocial.addClass('hidden');
            this.modalRecovery.addClass('hidden');
            this.modalLogin.addClass('hidden');
            this.modalCode.addClass('hidden');
            this.modalPassword.addClass('hidden');
            this.modalWelcome.removeClass('hidden');
        });
        // login email
        this.btnLoginEmail.on('click', (e)=>{
            e.preventDefault();
            this.modalRegisterSocial.addClass('hidden');
            this.modalRecovery.addClass('hidden');
            this.modalWelcome.addClass('hidden');
            this.modalCode.addClass('hidden');
            this.modalPassword.addClass('hidden');
            this.modalLogin.removeClass('hidden');
        });
        // back login
        this.modalLogin.find('.close').on('click', ()=>{
            this.modalLogin.addClass('hidden');
            this.modalWelcome.removeClass('hidden');
        });
        // register
        this.btnRegisterEmail.on('click', (e)=>{
            e.preventDefault();
            this.modalLogin.addClass('hidden');
            this.modalRecovery.addClass('hidden');
            this.modalWelcome.addClass('hidden');
            this.modalRegisterSocial.addClass('hidden');
            this.modalCode.addClass('hidden');
            this.modalPassword.addClass('hidden');
            this.modalRegister.removeClass('hidden');
        });
        // back register
        this.modalRegister.find('.close').on('click', ()=>{
            this.modalRegister.addClass('hidden');
            this.modalRegisterSocial.removeClass('hidden');
        });
        // register social
        this.btnRegisterSocial.on('click', (e)=>{
            e.preventDefault();
            this.modalLogin.addClass('hidden');
            this.modalRegister.addClass('hidden');
            this.modalRecovery.addClass('hidden');
            this.modalWelcome.addClass('hidden');
            this.modalCode.addClass('hidden');
            this.modalPassword.addClass('hidden');
            this.modalRegisterSocial.removeClass('hidden');
        });
        // recovery
        this.btnRecovery.on('click', (e)=>{
            e.preventDefault();
            this.modalLogin.addClass('hidden');
            this.modalRegister.addClass('hidden');
            this.modalWelcome.addClass('hidden');
            this.modalCode.addClass('hidden');
            this.modalPassword.addClass('hidden');
            this.modalRecovery.removeClass('hidden');
        });
        // back recovery
        this.modalRecovery.find('.close').on('click', ()=>{
            this.modalRecovery.addClass('hidden');
            this.modalLogin.removeClass('hidden');
        });
        // back code
        this.modalCode.find('.close').on('click', ()=>{
            this.modalCode.addClass('hidden');
            this.modalRecovery.removeClass('hidden');
        });
        // back password
        this.modalPassword.find('.close').on('click', ()=>{
            this.modalPassword.addClass('hidden');
            this.modalCode.removeClass('hidden');
        });
        // toggle pass
        this.btnTogglePassword.on('click', ()=>{
            this.btnTogglePassword.parent().find('#user_password').attr('type', this.btnTogglePassword.parent().find('#user_password').attr('type') === 'text' ? 'password' : 'text');
            window.jQuery('.q-icon-eye, .q-icon-eye-off').toggleClass('q-icon-eye-off q-icon-eye');
        });
        // form validator
        utils_validator__WEBPACK_IMPORTED_MODULE_2__/* ["default"].init */ .Z.init();
        new utils_form_submit_toggle__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z('#registration_form', true);
        this.recoveryFormValidation();
        this.codeFormValidation();
        this.passwordFormValidation();
        // regressive
        this.btnResend.on('click', ()=>{
            window.jQuery('#formRecoveryPassword').submit();
            this.btnResend.attr('disabled', 'disabled');
            this.regressive(60);
        });
    }
    getToken() {
        return _async_to_generator(function*() {
            const response = yield window.jQuery.post({
                url: '/oauth/token',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                data: _extends({}, credentials[window.RAILS_ENV], {
                    grant_type: 'client_credentials'
                })
            });
            return response == null ? void 0 : response.access_token;
        })();
    }
    recoveryFormValidation() {
        this.$formRecovery = window.jQuery('#formRecoveryPassword', this.container);
        this.modalRecovery = window.jQuery('#modal-recovery', this.container);
        this.modalCode = window.jQuery('#modal-code', this.container);
        var _this = this;
        this.$formRecovery.on('submit', /*#__PURE__*/ _async_to_generator(function*(e) {
            e.preventDefault();
            const textButton = window.jQuery(_this.$formRecovery.find('[type=submit]')[0]).text().trim();
            window.jQuery(_this.$formRecovery.find('[type=submit]')[0]).html('Aguarde...').attr('disabled', 'disabled');
            const token = yield _this.getToken();
            if (token) {
                const { user } = _this.$formRecovery.serializeObject();
                window.jQuery.ajax({
                    url: '/api/auth/users/reset_passwords/start',
                    method: 'POST',
                    dataType: 'json',
                    data: {
                        email: user.email
                    },
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    success: ()=>{
                        _this.email = user.email;
                        _this.modalCode.removeClass('hidden');
                        _this.modalRecovery.addClass('hidden');
                        // regressive counter
                        _this.regressive(60);
                        // tracking
                        UserTracker.emit('event', {
                            eventName: 'new password email submitted',
                            data: {
                                request_path: window.location.pathname,
                                code_validation_status: 200
                            }
                        });
                    },
                    complete: ()=>{
                        window.jQuery(_this.$formRecovery.find('[type=submit]')[0]).html(textButton).removeAttr('disabled');
                    },
                    error: ()=>{
                        utils_validator__WEBPACK_IMPORTED_MODULE_2__/* ["default"].validate.showError */ .Z.validate.showError(_this.$formCode.find('#code')[0], 'E-mail inválido ou não existe');
                        // tracking
                        UserTracker.emit('event', {
                            eventName: 'new password email submitted',
                            data: {
                                request_path: window.location.pathname,
                                code_validation_status: 500
                            }
                        });
                    }
                });
            }
        }));
    }
    codeFormValidation() {
        this.$formCode = window.jQuery('#formCode', this.container);
        this.modalCode = window.jQuery('#modal-code', this.container);
        this.modalPassword = window.jQuery('#modal-password', this.container);
        var _this = this;
        this.$formCode.on('submit', /*#__PURE__*/ _async_to_generator(function*(e) {
            e.preventDefault();
            const textButton = window.jQuery(_this.$formCode.find('[type=submit]')[0]).text().trim();
            window.jQuery(_this.$formCode.find('[type=submit]')[0]).html('Aguarde...').attr('disabled', 'disabled');
            const token = yield _this.getToken();
            if (token) {
                const { code } = _this.$formCode.serializeObject();
                window.jQuery.ajax({
                    url: '/api/auth/users/reset_passwords/check',
                    method: 'POST',
                    dataType: 'json',
                    data: {
                        code,
                        email: _this.email
                    },
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    success: (response)=>{
                        _this.modalCode.addClass('hidden');
                        _this.modalPassword.removeClass('hidden');
                        // tracking
                        UserTracker.emit('event', {
                            eventName: 'new password code submitted',
                            data: {
                                request_path: window.location.pathname,
                                code_validation_status: 200,
                                code_validation_message: JSON.stringify(response)
                            }
                        });
                    },
                    complete: ()=>{
                        window.jQuery(_this.$formCode.find('[type=submit]')[0]).html(textButton).removeAttr('disabled');
                    },
                    error: (error)=>{
                        utils_validator__WEBPACK_IMPORTED_MODULE_2__/* ["default"].validate.showError */ .Z.validate.showError(_this.$formCode.find('#code')[0], 'Código expirado ou inválido');
                        // tracking
                        UserTracker.emit('event', {
                            eventName: 'new password code submitted',
                            data: {
                                request_path: window.location.pathname,
                                code_validation_status: 500,
                                code_validation_message: JSON.stringify(error.responseJSON)
                            }
                        });
                    }
                });
            }
        }));
    }
    passwordFormValidation() {
        this.$formPassword = window.jQuery('#formPassword', this.container);
        this.modalPassword = window.jQuery('#modal-password', this.container);
        this.modalLogin = window.jQuery('#modal-login', this.container);
        var _this = this;
        this.$formPassword.on('submit', /*#__PURE__*/ _async_to_generator(function*(e) {
            e.preventDefault();
            const textButton = window.jQuery(_this.$formPassword.find('[type=submit]')[0]).text().trim();
            window.jQuery(_this.$formPassword.find('[type=submit]')[0]).html('Aguarde...').attr('disabled', 'disabled');
            const token = yield _this.getToken();
            if (token) {
                const { user } = _this.$formPassword.serializeObject();
                window.jQuery.ajax({
                    url: '/api/auth/users/reset_passwords/confirm',
                    method: 'POST',
                    dataType: 'json',
                    data: {
                        email: _this.email,
                        password: user.password
                    },
                    headers: {
                        Authorization: `Bearer ${token}`
                    },
                    success: ()=>{
                        _this.modalPassword.addClass('hidden');
                        _this.modalLogin.removeClass('hidden');
                        _this.email = null;
                    },
                    complete: ()=>{
                        window.jQuery(_this.$formPassword.find('[type=submit]')[0]).html(textButton).removeAttr('disabled');
                    },
                    error: ()=>utils_validator__WEBPACK_IMPORTED_MODULE_2__/* ["default"].validate.showError */ .Z.validate.showError(_this.$formCode.find('#code')[0], 'Senha inválida')
                });
            }
        }));
    }
    regressive(timeRemaining) {
        const $counter = window.jQuery('#countTimer', this.container);
        const $buttonResend = window.jQuery('#resendCode', this.container);
        $counter.html(`O código expira em <strong>${timeRemaining}</strong> segundo(s)`);
        let initialTime = timeRemaining;
        let seconds;
        seconds = setInterval(()=>{
            initialTime--;
            $counter.html(`O código expira em <strong>${initialTime}</strong> segundo(s)`);
            if (initialTime <= 0) {
                clearInterval(seconds);
                $counter.text('O código expirou. Solicite um novo no botão abaixo');
                $buttonResend.removeAttr('disabled');
            }
        }, 1000);
    }
    static requestCode(email, token, callbackSuccess, callbackEnd, callbackError) {
        window.jQuery.ajax({
            url: '/api/auth/users/reset_passwords/start',
            method: 'POST',
            dataType: 'json',
            data: {
                email
            },
            headers: {
                Authorization: `Bearer ${token}`
            },
            success: callbackSuccess,
            complete: callbackEnd,
            error: callbackError
        });
    }
    constructor(container, newModal){
        this.email = null;
        this.container = container;
        newModal ? this.initNew() : this.init();
    }
}
class LoginRegister {
    static newLoginModal(return_url, data = {}) {
        utils_ajax_component_loader__WEBPACK_IMPORTED_MODULE_0__/* ["default"].load */ .Z.load({
            component: 'modals/login_register_modal',
            type: 'component',
            data: _extends({
                return_url
            }, data)
        }).then((html)=>{
            var _$_data, _$;
            const $loginContainer = window.jQuery('#js-login-register-modal');
            if ($loginContainer.length > 0) {
                $loginContainer.remove();
            }
            window.jQuery('body').append(html);
            const modal = utils_modal_manager__WEBPACK_IMPORTED_MODULE_1__/* ["default"].open */ .Z.open('#js-login-register-modal');
            new LoginRegisterModal(modal, window.jQuery('#js-login-register-modal').hasClass('q-auth-modal'));
            // tracking events
            if ((_$ = window.jQuery(modal)) == null ? void 0 : (_$_data = _$.data) == null ? void 0 : _$_data.call(_$, 'trackingEvent')) {
                UserTracker.emit('event', {
                    eventName: 'account create paywall opened',
                    data: {
                        request_path: return_url
                    }
                });
            }
            if (data.trackingEvent) {
                UserTracker.emit('event', data.trackingEvent);
            }
        }).catch(()=>{
            Turbolinks.visit(`/conta/entrar?return_url=${return_url}`);
        });
    }
}



/***/ }),

/***/ 87322:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var _serialize_object__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49539);
/* harmony import */ var _serialize_object__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_serialize_object__WEBPACK_IMPORTED_MODULE_0__);

class ModalManager {
    static bindForm($modal, callback) {
        const $form = window.jQuery('form', $modal);
        if (!$form.length) {
            return;
        }
        $form.off('submit.form').on('submit.form', (e)=>{
            e.preventDefault();
            const formData = $form.serializeObject();
            $modal.modal('hide');
            callback(formData, window.jQuery(e.currentTarget));
            $form.clearForm();
        });
    }
    static populate(selector, data) {
        const $modalElement = selector.jquery ? selector : window.jQuery(selector);
        for(const itemName in data){
            const $element = $modalElement.find(`[data-modal-${itemName}]`);
            const value = data[itemName];
            if ($element.is('button')) {
                value ? $element.show() : $element.hide();
            }
            if ($element.attr('value') !== undefined) {
                $element.val(value);
            } else {
                $element.html(value);
            }
        }
    }
    static bindButtons($modal, callback) {
        window.jQuery('#js-ok-btn', $modal).off('click').on('click', (e)=>{
            e.preventDefault();
            $modal.modal('hide');
            if (callback && typeof callback === 'function') {
                callback(true);
            }
        });
        window.jQuery('#js-cancel-btn', $modal).off('click').on('click', (e)=>{
            e.preventDefault();
            $modal.modal('hide');
            if (callback && typeof callback === 'function') {
                callback(false);
            }
        });
    }
    static dispatchEvents(selector) {
        const eventName = {
            '#modal-id': 'event name'
        }[selector];
        if (eventName === undefined) {
            return;
        }
        UserTracker.emit('event', {
            eventName
        });
    }
    static open(selector, callback) {
        const $modalElement = selector.jquery ? selector : window.jQuery(selector);
        const $modal = $modalElement.modal();
        const isCallbackEnabled = callback && typeof callback === 'function';
        if (isCallbackEnabled) {
            ModalManager.bindForm($modal, callback);
        }
        ModalManager.bindButtons($modal, isCallbackEnabled ? callback : null);
        ModalManager.dispatchEvents(selector);
        $modal.modal('show');
        return $modal;
    }
    static close($modal) {
        $modal.modal('hide');
    }
}
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (ModalManager);


/***/ }),

/***/ 49539:
/***/ (() => {

/* eslint-disable no-prototype-builtins */ (function($) {
    $.fn.serializeObject = function(castValues = true, alwaysReturnKeys = false) {
        let self = this, json = {}, push_counters = {}, patterns = {
            'validate': /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
            'key': /[a-zA-Z0-9_]+|(?=\[\])/g,
            'push': /^$/,
            'fixed': /^\d+$/,
            'named': /^[a-zA-Z0-9_]+$/
        };
        this.isJsonString = function(str) {
            try {
                JSON.parse(str);
            } catch (e) {
                return false;
            }
            return true;
        };
        this.castValues = (obj)=>{
            // eslint-disable-next-line no-unused-vars
            for(const key in obj){
                if (!obj.hasOwnProperty(key)) continue;
                let value = obj[key];
                if (typeof value === 'undefined' || value === null || value.toString().length === 0) continue;
                if (typeof value === 'object') {
                    value = this.castValues(value);
                } else if (value === 'true') {
                    value = true;
                } else if (value === 'false') {
                    value = false;
                } else if (!isNaN(value)) {
                    value = parseFloat(value);
                } else if (this.isJsonString(value)) {
                    value = JSON.parse(value);
                }
                obj[key] = value;
            }
            return obj;
        };
        this.build = function(base, key, value) {
            if (alwaysReturnKeys || value && value.toString().length) base[key] = value;
            return base;
        };
        this.push_counter = function(key) {
            if (push_counters[key] === undefined) {
                push_counters[key] = 0;
            }
            return push_counters[key]++;
        };
        $.each($(this).serializeArray(), function() {
            // skip invalid keys
            if (!patterns.validate.test(this.name)) {
                return;
            }
            let k, keys = this.name.match(patterns.key), merge = this.value, reverse_key = this.name;
            while((k = keys.pop()) !== undefined){
                // adjust reverse_key
                reverse_key = reverse_key.replace(new RegExp('\\[' + k + '\\]$'), '');
                if (k.match(patterns.push)) {
                    merge = self.build([], self.push_counter(reverse_key), merge);
                } else if (k.match(patterns.fixed)) {
                    merge = self.build([], k, merge);
                } else if (k.match(patterns.named)) {
                    merge = self.build({}, k, merge);
                }
            }
            json = $.extend(true, json, merge);
        });
        return castValues ? this.castValues(json) : json;
    };
})(window.jQuery);


/***/ }),

/***/ 29483:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (/* binding */ SessionExpired)
/* harmony export */ });
/* harmony import */ var utils_ajax_component_loader__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62346);
/* harmony import */ var utils_modal_manager__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87322);


class SessionExpired {
    static renewSessionModal(return_url) {
        utils_ajax_component_loader__WEBPACK_IMPORTED_MODULE_0__/* ["default"].load */ .Z.load({
            component: 'modals/session_expired_modal',
            type: 'component',
            data: {
                return_url: return_url
            }
        }).then((html)=>{
            window.jQuery('body').append(html);
            if (gon.flags.session_expired_debug) {
                UserTracker.emit('event', {
                    eventName: 'expired session',
                    data: {
                        request_path: window.location.pathname,
                        cookie_my_app_session: Boolean(window.currentUser),
                        cookie_remember_user_token: Boolean(window.currentUser)
                    }
                });
            }
            utils_modal_manager__WEBPACK_IMPORTED_MODULE_1__/* ["default"].open */ .Z.open('#js-session-expired-modal');
        }).catch(()=>{
            Turbolinks.visit(`/conta/entrar?return_url=${return_url}`);
        });
    }
}



/***/ }),

/***/ 91337:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var validate__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2259);
/* harmony import */ var validate__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(validate__WEBPACK_IMPORTED_MODULE_0__);
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}

// https://github.com/cferdinandi/validate/blob/master/package.json
// import and run validate.init();
const defaultConfig = {
    // Classes and Selectors
    selector: '[data-validate]',
    fieldClass: 'has-error',
    errorClass: 'help-block',
    // Messages
    messageValueMissing: 'Campo obrigatório.',
    messageValueMissingSelect: 'Selecione uma opção.',
    messageTypeMismatchEmail: 'Digite um e-mail válido.',
    messageTypeMismatchURL: 'Insira uma URL válida.',
    messageTooShort: 'Deve ter {minLength} caracteres ou mais.',
    messageTooLong: 'Deve ter {maxLength} caracters ou menos. Você está usando {length} caracteres.',
    messagePatternMismatch: 'Formato inválido.',
    messageBadInput: 'Insira apenas números.',
    messageStepMismatch: 'Selecione um valor válido.',
    messageRangeOverflow: 'Selecione um valor acima de {max}.',
    messageRangeUnderflow: 'Selecione um valor abaixo de {min}.',
    messageGeneric: 'Valor inválido.',
    // Custom
    createFeedbackIcon (className) {
        let node = document.createElement('i');
        node.classList.add('form-control-feedback', 'js-form-control-feedback', 'q-icon', `q-icon-${className}`);
        return node;
    },
    // Form Submission
    disableSubmit: false,
    customValidity: {
        badConfirm: {
            check (field) {
                if (!field.hasAttribute('confirm')) return false;
                const value = field.value;
                const fieldToCompare = field.getAttribute('confirm');
                const fieldToCompareValue = field.form.querySelector(`#${fieldToCompare}`).value;
                return value !== fieldToCompareValue;
            },
            message: 'O valor não é igual.'
        }
    },
    // onSubmit() {},
    // Callbacks
    beforeShowError (field) {
        const parent = field.parentNode;
        if (parent.classList.contains('form-group') || parent.classList.contains('input-group')) {
            const formControl = parent.querySelector('.js-form-control-feedback');
            parent.classList.remove('has-success', 'has-error', 'has-warning');
            parent.classList.add('has-error', 'has-feedback');
            if (formControl) formControl.remove();
            parent.appendChild(this.createFeedbackIcon('times-circle'));
        }
    },
    // afterShowError(field, error) {}
    beforeRemoveError (field) {
        const parent = field.parentNode;
        if (parent.classList.contains('form-group') || parent.classList.contains('input-group')) {
            const formControl = parent.querySelector('.js-form-control-feedback');
            parent.classList.remove('has-success', 'has-error', 'has-warning');
            parent.classList.add('has-feedback', 'has-success');
            if (formControl) formControl.remove();
            parent.appendChild(this.createFeedbackIcon('check-circle'));
        }
    }
};
const validator = {
    config: defaultConfig,
    validate: (validate__WEBPACK_IMPORTED_MODULE_0___default()),
    init (config = null) {
        const expandedConfig = _extends({}, defaultConfig, config);
        validate__WEBPACK_IMPORTED_MODULE_0___default().init(expandedConfig);
    }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (validator);


/***/ })

}]);